<template>
  <a-card class="info-wrap" style="border:none">
     <ul class="sup mb10">
        <li>
          <h3 class="name">{{ detail.name }}</h3>
          <div>{{ detail.number }}</div>
        </li>
        <li>
          {{ stateCn(detail.state) }}
        </li>
        <li>
          <dl>
            <dt>任务类型：</dt>
            <dd>  {{toCnHandle(detail.type, taskType) }} </dd>
          </dl>
        
        </li>
      </ul>
     <div class="sub">
      <dl>
        <dt>团队:</dt>
        <dd>{{detail.createTeamName}}</dd>
      </dl>
      <dl>
        <dt>发布人:</dt>
        <dd>{{ detail.createUserName }}</dd>
      </dl>
      <dl>
        <dt>发布时间:</dt>
        <dd>{{detail.createTime}}</dd>
      </dl>
      <dl>
        <dt>要求完成时间:</dt>
        <dd>{{detail.endTime}}</dd>
      </dl>    
     </div> 
  </a-card>
</template>
<script>
import {reactive, computed} from 'vue'
// import store from '@/store/index'
import {useStore} from '@/store/index2'
import { getCompanyName, getTeamName, getRoleName, getUserName, statusToCn } from '@/filters'

export default {  
  props:['info'],
  setup(props){

    // let info = {
    //   name:'',
    //   visible:'',
    //   status:'',
    //   type:'',
    //   typeCn:'',
    //   number:'',
    //   team:'',
    //   author:'',
    //   time:'',
    //   endTime:''
    // }

    let store = useStore()
    let taskType = store.taskType



    let detail = computed(()=>{
        return props.info
    })

    function teamName(id){
      return getTeamName(id)
    }

    function userName(id){
      return getUserName(id)
    }

    function toCnHandle(value, stateObj){
      return statusToCn(value, stateObj)
    }

    function stateCn(value){
      return store.getStateName(value)
    }

    return {
      detail,
      taskType,
      teamName,
      userName,
      toCnHandle,
      stateCn
    }
  }
}
</script>
<style lang="less">
.sup{
  display: flex;
  .name{
    font-size: 18px;
    font-weight: bold;  
  }
  dl{
    display: flex;
  }
  li{
    margin-right:50px;
  }

}
.sub{
  display: flex;
  dl{
    display: flex;
    margin-right:50px;
  }
}
</style>
